const initialState = {
  pendingSaleTrades: [],
  pendingPagination: {},
  requested: [],
  requestedPagination: {}
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case "SAVE_PENDING_TRADES":
      return {
        ...state,
        pendingSaleTrades: payload.pendingSaleTrades,
        pendingPagination: payload.pagination
      }

    case "UPDATE_SALE_TRADE":
      // Remove the accepted/rejected trade from the pending list so the table
      // refreshes immediately without a round-trip to the server.
      return {
        ...state,
        pendingSaleTrades: state.pendingSaleTrades.filter(
          saleTrade => saleTrade.id !== payload.id
        )
      }

    case "SAVE_REQUESTED_TRADES":
      return { ...state, ...payload }

    case "MOVE_TO_REQUESTED_SALES":
      state.requested.unshift(payload.sale)
      return {
        ...state
      }
    default:
      return state
  }
}
